/**
 * API Configuration
 * Centralized configuration for API endpoints
 * Automatically detects whether to use localhost or Traefik proxy
 */

// Detect access method
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

// Build API URL based on access method
// On localhost: direct backend connection
// On network/Traefik: relative URL (proxied by nginx/Traefik)
export const API_BASE_URL = isLocalhost
  ? `http://localhost:8001/api`
  : '/api'

// Log configuration for debugging (development only)
if (import.meta.env.DEV) {
  console.log('API Configuration:', {
    hostname: window.location.hostname,
    isLocalhost,
    apiBaseUrl: API_BASE_URL,
  })
}

// Backend base URL (for uploads and other non-API paths)
export const BACKEND_BASE_URL = isLocalhost
  ? 'http://localhost:8001'
  : ''

// SSO Identity Provider URL (browser-facing)
// When accessed via Cloudflare tunnel (fmea-studio.com), use the public AUTH URL
// When accessed locally (fmea.local), use the LAN AUTH URL
function getAuthUrl(): string {
  if (import.meta.env.VITE_AUTH_URL) return import.meta.env.VITE_AUTH_URL
  if (window.location.hostname.endsWith('fmea-studio.com')) return 'https://auth.fmea-studio.com'
  return 'http://auth.local'
}
export const AUTH_URL = getAuthUrl()

export default API_BASE_URL
